import React, { useState, useEffect } from "react";

import { BiSolidCheckSquare, BiSolidXSquare } from "react-icons/bi";
import { HiOutlineEye } from "react-icons/hi";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import Confirm from "../assets/img/confirm.png";
import { useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import axiosInstanceAuthFormData from "../../apiInstances/axiosInstanceAuthFormData";
import { PropagateLoader } from "react-spinners";
import useEncryption from "../useEncryption/useEncryption";
import { usePagination } from "../Pagination/usePagination";
import { io } from "socket.io-client";
const TodoListAdmin = ({ searchUser }) => {
  const navigate = useNavigate();
  const { decryptData } = useEncryption();
  const [isLoading, setIsLoading] = useState(false);

  const [open, setOpen] = React.useState(false);
  const [openUpload, setOpenUpload] = React.useState(false);
  const [uploadrole, setUploadrole] = useState("");
  const [allTodoData, setAllTodoData] = useState([]); // use User Table time this state
  const [filterdata, setFilterdata] = useState([]);
  const [socket, setSocket] = useState(null);

  const [admin, setAdmin] = useState("");
  console.log("adminm>>>>>>>>", admin);
  const { sliceData, currentPage, numbers, totalPages, goToPage } =
    usePagination(filterdata, 10);

  useEffect(() => {
    const results = allTodoData.filter((item) => {
      const searchTerm = searchUser.toLowerCase();
      const itemNameMatch =
        item?.name?.toLowerCase().includes(searchTerm) ||
        item?.assigndate?.toLowerCase().includes(searchTerm) ||
        item?.deadline?.toLowerCase().includes(searchTerm);
      return itemNameMatch;
    });
    setFilterdata(results);
    goToPage(1);
  }, [searchUser]);

  const handleOpen = () => setOpen(!open);

  // Successfully Popup
  const [showForm, setShowForm] = useState(false);

  const [getId, setId] = useState(""); // use Upload file API

  const toggleForm = () => {
    setShowForm(true);
  };

  const closePopup = () => {
    setShowForm(false);
  };

  useEffect(() => {
    if (showForm) {
      const timer = setTimeout(() => {
        setShowForm(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showForm]);

  const [role, setRole] = useState("");

  const gettodolistdata = async () => {
    let apiEndpoint = "/gettask_admin";

    const userRole = localStorage.getItem("Role");
    console.log(
      "roleeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
      userRole
    );

    if (userRole === "user") {
      apiEndpoint = "/gettask"; // Change API endpoint for user role
    }

    try {
      const res = await axiosInstanceAuth.get(apiEndpoint);

      const myData = decryptData(res?.data?.data);
      setAllTodoData(myData?.data);
      setFilterdata(myData?.data);
      // const firstItem = myData?.data[0];
      // const adminId = firstItem?.adminId;
      // setAdminId(adminId);
      for (let d of myData?.data) {
        if (d?.adminId) {
          setAdmin(d?.adminId);
        }
      }
      console.log("ToDOTableData jenu jenu jenu---->", myData?.data);
      for (let d of myData?.data) {
        if (d.role) {
          setRole(d.role);
        }
      }
    } catch (err) {
      console.log("err --->", err);
    }
  };

  useEffect(() => {
    gettodolistdata();
  }, []);
  //socket through notification
  const emitEditMessage = (admin) => {
    console.log("edit==========================================> ", admin);
    socket.emit("edit_todo", { id: admin });

    console.log("Hello EditTodo Done");
  };
  const emitEdittodoMessage = (admin) => {
    const abc = {
      targetUserId: admin,
      message: "you have a new notification",
    };
    socket.emit("edit_todo_message", abc);
    console.log("new message send");
  };

  // ======== Tags Input Start ===========
  const [tags, setTags] = useState([]);
  const [currentTag, setCurrentTag] = useState("");

  const handleInputChange = (event) => {
    setCurrentTag(event.target.value);
  };

  const handleInputKeyDown = (event) => {
    if (event.key === "Enter" && currentTag.trim() !== "") {
      setTags([...tags, currentTag.trim()]);
      setCurrentTag("");
    }
  };

  const removeTag = (tagIndex) => {
    const updatedTags = tags.filter((_, index) => index !== tagIndex);
    setTags(updatedTags);
  };

  // ======== Date Format Start ===========
  const [formattedDate, setFormattedDate] = useState("");

  const handleDateChange = (event) => {
    const inputDate = event.target.value;
    const [year, month, day] = inputDate.split("-");

    const formatted = `${day}/${month}/${year}`;
    setFormattedDate(formatted);
  };

  // Upload File API

  const [fileFields, setFileFields] = useState({
    attachment: "",
  });

  const onChangeUploadFile = (e) => {
    const { name } = e.target;
    setFileFields({
      ...fileFields,
      [name]: e.target.files[0],
    });
  };

  const viewAdminTodoList = (id, rolesss) => {
    localStorage.setItem("ManageRole", rolesss);
    navigate(`/adminTodolistview/${id}`);
  };
  useEffect(() => {
    if (isLoading === true) {
      const loadingTimeout = setTimeout(() => {
        // setOpenEdit(true);
        gettodolistdata();
        setIsLoading(false);
      }, 2000);
      return () => {
        clearTimeout(loadingTimeout); // Clear the timeout if the component unmounts
      };
    }
  }, [isLoading]);
  const UplodaFileApi = async (id, uprole) => {
    console.log(id, "id from upload");
    try {
      const formData = new FormData();

      formData.append("attachment", fileFields?.attachment);
      // formData.append("role", uprole);

      const userRole = localStorage.getItem("Role");
      let apiEndpoint = `uploaddoc_admin/${getId}`;

      if (userRole === "user") {
        apiEndpoint = `uploaddoc/${getId}`;
      }

      axiosInstanceAuthFormData
        .post(apiEndpoint, formData)
        .then((res) => {
          const myData = decryptData(res?.data?.data);
          console.log("__###__#####", myData);
          if (myData?.status) {
            setFileFields(id);
            gettodolistdata();
            emitEdittodoMessage(admin);
            emitEditMessage(admin);

            toast.success(myData?.message);
            setIsLoading(true);
          } else {
            toast.error(myData?.message);
          }
          setOpenUpload(false);
        })
        .catch((err) => {
          console.log("------>> Error", err);
        });
    } catch (error) {
      console.error(error);
    }
  };

  // File Upload Modal Open

  const modelShowUpload = (id, role) => {
    setUploadrole(role);
    setOpenUpload(true);
    setId(id);
  };
  useEffect(() => {
    const newSocket = io(BACKEND_BASE_URL, { query: { admin } });
    console.log("userid:::", admin);
    setSocket(newSocket);

    newSocket.on("todo_updated", (data) => {
      console.log("TODO updated:", data);
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);
  return (
    <>
      {isLoading ? (
        <div className="loading-animation flex justify-center items-center pt-80">
          <PropagateLoader color="#22345C" />
          {/* ...loading */}
        </div>
      ) : (
        <>
          <div className="container">
            {/* frist popup */}
            {open ? (
              <>
                <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center ">
                  <div className="h-auto  filter-screen-model outline-none bg-white rounded-2xl shadow-2xl mx-5 ">
                    <div>
                      <div>
                        <div className=" border-[1.5px] border-[#000000] m-10 rounded-[20px] p-">
                          <div className="flex justify-center items-center">
                            <div className="absolute">
                              <button class="bg-[#22345C] text-lg text-white font-sans underline font-bold py-2 px-4 rounded-[10px]">
                                Create New Task
                              </button>
                            </div>
                          </div>
                          <div className="p-5">
                            <div class="grid grid-cols-1 gap-6 mt-4 lg:grid-cols-">
                              <div>
                                <label
                                  class="text-[#22345C] underline font-sans font-bold text-lg"
                                  for="username"
                                >
                                  Task Name
                                </label>
                                <input
                                  id="username"
                                  type="text"
                                  class="block w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                                />
                              </div>

                              <div>
                                <label
                                  class="text-[#22345C] underline font-sans font-bold text-lg"
                                  for="username"
                                >
                                  Task Description (Optional)
                                </label>
                                <input
                                  id="username"
                                  type="text"
                                  class="block w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                                />
                              </div>

                              <div className="space-y-2">
                                <div>
                                  <label
                                    class="text-[#22345C] underline font-sans font-bold text-lg"
                                    for="username"
                                  >
                                    Assigned To
                                  </label>
                                </div>
                                <div className="flex w-96 flex-wrap gap-2 border border-[#233966] rounded-md p-2">
                                  {tags.map((tag, index) => (
                                    <div
                                      key={index}
                                      className="bg-[#233966] text-white px-2 py-1 rounded-md cursor-pointer"
                                      onClick={() => removeTag(index)}
                                    >
                                      {tag}
                                    </div>
                                  ))}
                                  <input
                                    type="text"
                                    // placeholder="Add a tag"
                                    value={currentTag}
                                    onChange={handleInputChange}
                                    onKeyDown={handleInputKeyDown}
                                    className="outline-none border-none flex-grow "
                                  />

                                  {/* <select
                              class="border-black border-[1px] px-2 py-2 mt-2 text-[#000000] font-sans  rounded-md   block w-full p-2.5 focus:outline-none"
                              name="employeRole"
                              value={currentTag}
                              onChange={handleInputChange}
                              onKeyDown={handleInputKeyDown}
                            >
                              <option selected disabled>
                                Choose a any
                              </option>
                              <option>Supervisior</option>
                              <option>Team Leader</option>
                              <option>Project Manager</option>
                              <option>Chief Engineer</option>
                              <option>Other</option>
                            </select> */}
                                </div>
                              </div>

                              <div>
                                <label
                                  class="text-[#22345C] underline font-sans font-bold text-lg"
                                  for="username"
                                >
                                  Role
                                </label>
                                <input
                                  id="username"
                                  type="text"
                                  class="block w-96 px-2 py-2 mt-2  text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                                />
                              </div>

                              <div>
                                <label
                                  class="text-[#22345C] underline font-sans font-bold text-lg"
                                  for="username"
                                >
                                  Assigned Date
                                </label>
                                <input
                                  id="username"
                                  type="date"
                                  class="block w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                                  onChange={handleDateChange}
                                />
                              </div>

                              <div>
                                <label
                                  class="text-[#22345C] underline font-sans font-bold text-lg"
                                  for="username"
                                >
                                  Deadline
                                </label>
                                <input
                                  id="username"
                                  type="date"
                                  class="block w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                                  onChange={handleDateChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div class="flex justify-center mt-7 gap-4 mb-5">
                            <div className="">
                              <button
                                onClick={() => {
                                  handleOpen();
                                  toggleForm();
                                }}
                                // onClick={toggleForm}
                                class="bg-[#5DC90A]  px-6 py-2 leading-5  text-white font-bold  rounded-[6px]"
                              >
                                Save
                              </button>
                            </div>
                            <div>
                              <button
                                onClick={handleOpen}
                                class="bg-[#FF270E] px-6 py-2 leading-5 text-white font-bold rounded-[6px]"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {/* upload popup */}
            {openUpload ? (
              <>
                <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center ">
                  <div className="h-auto  filter-screen-model outline-none bg-white rounded-2xl shadow-2xl mx-5 ">
                    <div>
                      <div>
                        <div className=" border-[1.5px] border-[#000000] m-10 rounded-[20px] p-">
                          <div className="flex justify-center items-center">
                            <div className="absolute">
                              <button className="bg-[#22345C] text-lg text-white font-sans underline font-bold py-2 px-4 rounded-[10px]">
                                Supporting Document
                              </button>
                            </div>
                          </div>
                          <div className="p-5">
                            <div class="grid grid-cols-1 gap-6 mt-4 lg:grid-cols-">
                              <div>
                                <label
                                  className="text-[#22345C] underline font-sans font-bold text-lg"
                                  for="username"
                                >
                                  File Upload{" "}
                                  <span className="text-red-500">*</span>{" "}
                                </label>

                                <input
                                  type="file"
                                  className="block w-96 px- py- file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-md file:font-semibold file:bg-[#22345C] file:text-white font-sans mt-2 text-[#000000] bg-[#F0F0F0] rounded-md outline-none"
                                  name="attachment"
                                  onChange={onChangeUploadFile}
                                />
                              </div>
                            </div>
                          </div>

                          <div class="flex justify-center mt-7 gap-4 mb-5">
                            <div className="">
                              <button
                                onClick={() => {
                                  UplodaFileApi(getId, uploadrole);
                                }}
                                className="bg-[#5DC90A]  px-6 py-2 leading-5  text-white font-bold  rounded-[6px]"
                              >
                                Submit
                              </button>
                            </div>
                            <div>
                              <button
                                onClick={() => setOpenUpload(false)}
                                className="bg-[#FF270E] px-6 py-2 leading-5 text-white font-bold rounded-[6px]"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {/* second popup end  */}
            {showForm ? (
              <>
                <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center ">
                  <div className="h-auto  filter-screen-model outline-none  rounded-2xl shadow-2xl mx-5 ">
                    <div className="relative">
                      <div className="bg-[#17C09E] rounded-t-[10px] shadow-lg z-10 h-4"></div>
                      <div className="bg-white p-5 rounded-b-[23px] shadow-lg z-10">
                        <div className=" border-[1.5px] border-[#000000] m-2 rounded-[10px] ">
                          <div className="p-5">
                            <div className="flex justify-center">
                              <img src={Confirm} alt="" />
                            </div>
                            <div>
                              <p className="text-[#000000] mt-5 mx-24 font-sans font-bold text-2xl">
                                New task created Successfully
                              </p>
                            </div>
                            <div className="flex justify-center">
                              <button
                                className="mt-8 bg-[#22345C] text-white font-semibold py-1 justify-center px-8 rounded-[18px] focus:outline-none  "
                                onClick={closePopup}
                              >
                                Okay
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            {/* second popup end */}
            {/* Table Show  */}

            <div>
              <div className="overflow-auto lg:overflow-visible mt-10">
                <table className="table w-full text-gray-400 border-separate space-y-6">
                  <thead className="bg-[#22345C] text-white lg:text-xl">
                    <tr>
                      <th className="p-3 text-left ">Task Title</th>
                      <th className="p-3 text-left ">Status</th>
                      <th className="p-3 text-center">Assigned Date</th>
                      <th className="p-3 text-center">Deadline</th>
                      <th className="p-3 text-center">Action</th>
                      {/* <th className="p-3 text-left">Action</th> */}
                      <th className="p-3 text-left">Supporting Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sliceData?.length > 0 &&
                      sliceData.map((d, index) => (
                        <>
                          <tr
                            key={index}
                            className="bg-[#F5F7FD] lg:text-black font-bold font-sans text-lg"
                          >
                            <td className="p-3 ">
                              <div>{d.name}</div>
                            </td>
                            <td className="p-3">
                              <div className="flex gap-1 items-center">
                                {d.status ? "Completed" : "Incompleted"}
                                <span>
                                  {d.status ? (
                                    <BiSolidCheckSquare
                                      size={25}
                                      className="text-[#5DC90A]"
                                    />
                                  ) : (
                                    <BiSolidXSquare
                                      size={25}
                                      className="text-[#FF270E]"
                                    />
                                  )}
                                </span>
                              </div>
                            </td>
                            <td className="p-3 whitespace-nowrap text-center">
                              {d.assigndate}
                            </td>
                            <td className="p-3 whitespace-nowrap text-center">
                              {d.deadline}
                            </td>
                            <td className="p-3 ">
                              <div className="relative gap-2 flex items-center justify-center  ">
                                <div>
                                  <HiOutlineEye
                                    onClick={() => {
                                      viewAdminTodoList(d?._id, d?.role);
                                    }}
                                    size={25}
                                    className="cursor-pointer  text-[#FFFFFF] bg-[#22345C] rounded-[3px] p-1"
                                  />
                                </div>
                              </div>
                            </td>

                            <td className="p-3 ">
                              <div className="flex items-center gap-2 ">
                                <div className=" gap-2 flex items-center justify-center  ">
                                  <div
                                    onClick={() =>
                                      modelShowUpload(d._id, d?.role)
                                    }
                                    size={25}
                                    className="cursor-pointer text-[#FFFFFF]  bg-[#5DC90A] rounded-[10px] py-1 px-2"
                                  >
                                    Upload
                                  </div>
                                </div>
                                <div
                                  className="text-center text-sm cursor-pointer"
                                  title={d.attachment}
                                >
                                  {d.attachment
                                    ? d.attachment.slice(0, 11) +
                                      (d.attachment.length > 5 ? "..." : "")
                                    : ""}
                                </div>
                              </div>
                            </td>
                          </tr>
                        </>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* pagination  */}
            {allTodoData?.length > 1 ? (
              <div className="flex gap-2 pb-5 bottom-0">
                <button
                  className="px-1 py-1 leading-tight  bg-[#FFFFFF] rounded-lg text-black text-xl"
                  disabled={currentPage === 1}
                  onClick={() => goToPage(currentPage - 1)}
                >
                  <GrFormPrevious size={25} />
                </button>

                {numbers.map((item, index) => (
                  <button
                    disabled={item === "..."}
                    className={`py-[3px] px-3  rounded-lg ${
                      currentPage === item &&
                      "bg-[#22345C] text-white font-bold font-sans"
                    }`}
                    onClick={() => goToPage(item)}
                    key={index}
                  >
                    {item}
                  </button>
                ))}

                <button
                  className=" px-1 py-1  leading-tight  bg-[#FFFFFF] rounded-lg text-black text-xl"
                  disabled={currentPage === totalPages}
                  onClick={() => goToPage(currentPage + 1)}
                >
                  <GrFormNext size={25} />
                </button>
              </div>
            ) : null}

            <div>
              <style
                dangerouslySetInnerHTML={{
                  __html:
                    "\n\n    .table {\n    border-spacing: 0 15px;\n  }\n\n  i {\n    font-size: 1rem !important;\n  }\n\n  .table tr {\n    border-radius: 20px;\n  }\n\n  tr td:nth-child(n + 6),\n  tr th:nth-child(n + 6) {\n    border-radius: 0 0.625rem 0.625rem 0;\n  }\n\n  tr td:nth-child(1),\n  tr th:nth-child(1) {\n    border-radius: 0.625rem 0 0 0.625rem;\n  }\n\n",
                }}
              />

              <link
                href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp"
                rel="stylesheet"
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TodoListAdmin;
